import styled, { css } from 'styled-components';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

export const Wrap = styled.div`
  background-color: #f5f5f5;
  overflow: hidden;
  height: 66px;
  ${(props) =>
    props.view &&
    css`
      overflow: visible;
      width: 100%;
      height: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 199;
      background-color: rgba(0, 0, 0, 0.8);
    `}
`;

export const StyledSlider = styled(Slider)``;

export const SliderItem = styled.div`
  display: flex;
  box-sizing: border-box;
  padding: 11px 10px;
  margin: 5px;
  border-radius: 5px;
  background-color: #f25a94;
  height: 56px;
  position: relative;
  ${(props) =>
    props.view &&
    css`
      height: initial;
    `};
  :after {
    content: '';
    position: absolute;
    right: -2px;
    top: -2px;
    width: 41px;
    height: 41px;
    background: url('/images/ribbon.png') no-repeat center center;
    background-size: 41px;
    display: block;
  }

  > a {
    display: flex;
    align-items: center;
    height: 34px;
    .thumb {
      width: 28px;
      height: 28px;
      position: relative;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      :before {
        position: absolute;
        content: '';
        top: 0;
        left: -1px;
        width: 30px;
        height: 30px;
        z-index: 2;
      }
      > img {
        width: 100%;
        height: 100%;
        border-radius: 100%;
      }
      .border {
        position: absolute;
        top: -1px;
        left: -1px;
        content: '';
        width: 30px;
        height: 30px;
      }
    }
  }

  > div {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-left: 13px;
    color: #fff;
    overflow: hidden;
    .nick {
      font-size: 13px;
      font-weight: bold;
      margin-bottom: 4px;
      line-height: 12px;
    }
    .message {
      font-size: 13px;
      padding-right: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 18px;
      word-break: break-all;
      &.open {
        overflow: initial;
        text-overflow: initial;
        white-space: initial;
      }

      > a {
        color: #1a15ff;
        text-decoration: underline;
        :before {
          content: '';
          display: inline-block;
          width: 12px;
          height: 12px;
          margin-right: 4px;
          background: url('/images/ic-link.svg') no-repeat center center;
          background-size: 12px;
        }
      }

      > label {
        color: #1a15ff;
        text-decoration: underline;
        input {
          width: 1px;
          height: 0;
          outline: none;
          border: none;
        }
        :before {
          content: '';
          display: inline-block;
          width: 12px;
          height: 12px;
          margin-right: 4px;
          background: url('/images/ic-copy.svg') no-repeat center center;
          background-size: 12px;
        }
      }
    }
  }
`;

export const PageView = styled.span`
  position: absolute;
  top: 13px;
  right: 31px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 10px;
  line-height: 8px;
`;

export const Buttons = styled.div`
  display: flex;
  margin: 6px 0;
  button {
    color: #fff;
    font-size: 12px;
  }
`;

export const ReportButton = styled.button`
  margin-left: auto;
  margin-right: 10px;
`;

export const DeleteButton = styled.button`
  margin-right: 10px;
`;
